<template>
  <div id="AmenitiesCards">
    <div
      class="amenitiesCard"
      v-for="(card, index) in cards"
      :key="'card' + index"
      @click="cardSetter(index)"
    >
      <div class="cardBox">
        <div class="icon">
          <img :src="require('@/assets/svgs/benefits/' + card.icon)" />
        </div>
        <div class="title" v-html="card.title" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AmenitiesCards",
    data() {
      return {
        cards: [
          {
            icon: "benefit-icon_percentage.svg",
            title: "20% discount off concessions and merchandise",
            active: false,
          },
          {
            icon: "benefit-icon_unlock.svg",
            title: "Access To<br />The United<br />Club Level",
            active: false,
          },
          {
            icon: "benefit-icon_pen.svg",
            title: "pregame autograph signings with denver broncos alumni & cheer",
            active: false,
          },
          {
            icon: "benefit-icon_calendar.svg",
            title: "exclusive united club events",
            active: false,
          },
          {
            icon: "benefit-icon_people.svg",
            title: "dedicated club seats account manager",
            active: false,
          },
          {
            icon: "benefit-icon_email.svg",
            title: "email<br />communication",
            active: false,
          },
          {
            icon: "benefit-icon_ticket.svg",
            title: "ticket<br />exchange",
            active: false,
          },
          {
            icon: "benefit-icon_football.svg",
            title: "Playoff & event opportunities",
            active: false,
          },
          {
            icon: "benefit-icon_list.svg",
            title: "club nfl pick-em challenge",
            active: false,
          },
          {
            icon: "benefit-icon_phone.svg",
            title: "mobile<br />tickets",
            active: false,
          },
        ]
      }
    },
    methods: {
      cardSetter(index) {
        if (!this.cards[index].active) {
          this.cards[0].active = false;
          this.cards[1].active = false;
          this.cards[2].active = false;
          this.cards[3].active = false;
          this.cards[4].active = false;
          this.cards[5].active = false;
          this.cards[6].active = false;
          this.cards[7].active = false;
          this.cards[8].active = false;
          this.cards[9].active = false;
          this.cards[index].active = true;
        } else {
          this.cards[index].active = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #AmenitiesCards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    .amenitiesCard {
      // cursor: pointer;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 192px;
      min-height: 176px;
      padding: 35px 18px 10px;
      background: rgba(235, 235, 235, 0.80);
      .cardBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          width: 45px;
          height: 39px;
          background: url('~@/assets/svgs/benefits/blue-triangle.svg') scroll no-repeat center center;
          background-size: 45px 39px;
          img {
            position: relative;
            bottom: 4px;
          }
        }
        .title {
          margin-top: 15px;
          font-size: 13px;
          @include nofex;
          line-height: 15px;
          text-align: center;
          color: #0B2241;
        }
      }
    }
  }
</style>

<style lang="scss">
  #AmenitiesCards {
    .amenitiesCard {
      .top {
        .title {
          font-family: Morganite-BlackItalic;
          font-size: 45px;
          line-height: 36px;
          color: #FFF;
          text-transform: uppercase;
          @media (max-width: $sm) {
            br {
              display: none;
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
</style>